import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9a9a170"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "req-shift" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "sidebar__list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__circle" }, "1", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__circle" }, "2", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__circle" }, "3", -1))
const _hoisted_7 = { class: "steps" }
const _hoisted_8 = { class: "steps__count" }
const _hoisted_9 = { class: "steps__single step-1" }
const _hoisted_10 = { class: "steps__title" }
const _hoisted_11 = { class: "steps__subtitle" }
const _hoisted_12 = { class: "step__single step-2" }
const _hoisted_13 = { class: "steps__title" }
const _hoisted_14 = { class: "steps__subtitle" }
const _hoisted_15 = { class: "step__single step-3" }
const _hoisted_16 = { class: "steps__title" }
const _hoisted_17 = { class: "steps__subtitle" }
const _hoisted_18 = { class: "steps__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_RichTextEditor = _resolveComponent("RichTextEditor")!
  const _component_DateTimePicker = _resolveComponent("DateTimePicker")!
  const _component_DragNDrop = _resolveComponent("DragNDrop")!
  const _component_FormGroup = _resolveComponent("FormGroup")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          spinning: _ctx.isLoading,
          inline: true
        }, null, 8, ["spinning"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", {
          class: _normalizeClass(["sidebar__item", { active: _ctx.currentStep === 1 }])
        }, [
          _createElementVNode("div", {
            class: "sidebar__item-title",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.stepClick(1)))
          }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("shift_request.step_title_1")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("shift_request.step_subtitle_1")), 1)
          ]),
          _hoisted_4
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["sidebar__item", { active: _ctx.currentStep === 2 }])
        }, [
          _createElementVNode("div", {
            class: "sidebar__item-title",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stepClick(2)))
          }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("shift_request.step_title_2")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("shift_request.step_subtitle_2")), 1)
          ]),
          _hoisted_5
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["sidebar__item", { active: _ctx.currentStep === 3 }])
        }, [
          _createElementVNode("div", {
            class: "sidebar__item-title",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stepClick(3)))
          }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("shift_request.step_title_3")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("shift_request.step_subtitle_3")), 1)
          ]),
          _hoisted_6
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("step")) + " " + _toDisplayString(_ctx.currentStep) + "/3", 1),
      _createVNode(_component_FormGroup, { "form-group": _ctx.formGroup }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t("shift_request.step_title_1")), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("shift_request.step_desc_1")), 1),
            _createVNode(_component_FormRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_FormLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("shift_request.form_title")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_TextInput, {
                  type: "text",
                  placeholder: _ctx.$t('shift_request.form_title_placeholder'),
                  "control-name": "title"
                }, null, 8, ["placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_FormRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_FormLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("shift_request.form_desc")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_RichTextEditor, {
                  "control-name": "description",
                  expandable: false,
                  placeholder: _ctx.$t('shift_request.form_desc_placeholder')
                }, null, 8, ["placeholder"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.currentStep === 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("shift_request.step_title_2")), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("shift_request.step_desc_2")), 1),
            _createVNode(_component_FormRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_FormLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("shift_request.form_start_date")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_DateTimePicker, {
                  "hide-on-date-time-select": true,
                  "min-date": _ctx.getCurrentDate(),
                  "default-time-date": _ctx.defaultTimeDateForStart,
                  "month-navigator": true,
                  placeholder: "dd/mm/yyyy",
                  "show-button-bar": true,
                  "step-minute": 15,
                  "control-name": "startDate",
                  "date-format": "dd/mm/yy",
                  "selection-mode": "single"
                }, null, 8, ["min-date", "default-time-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_FormRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_FormLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("shift_request.form_end_date")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_DateTimePicker, {
                  disabled: _ctx.disableEndDate,
                  "hide-on-date-time-select": true,
                  "min-date": _ctx.endDateMinValue,
                  "default-time-date": _ctx.defaultTimeDateForEnd,
                  "month-navigator": true,
                  placeholder: "dd/mm/yyyy",
                  "show-button-bar": true,
                  "step-minute": 15,
                  "control-name": "endDate",
                  "date-format": "dd/mm/yy",
                  "selection-mode": "single"
                }, null, 8, ["disabled", "min-date", "default-time-date"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.currentStep === 2]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t("shift_request.step_title_3")), 1),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("shift_request.step_desc_3")), 1),
            _createVNode(_component_FormRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_DragNDrop, {
                  ref: "dragDrop",
                  onOnListUpdate: _ctx.onListUpdate,
                  limit: _ctx.fileNumbLimit,
                  "file-size": _ctx.fileSize
                }, null, 8, ["onOnListUpdate", "limit", "file-size"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.currentStep === 3]
          ])
        ]),
        _: 1
      }, 8, ["form-group"]),
      _createElementVNode("div", _hoisted_18, [
        (_ctx.currentStep > 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.prevClick())),
              color: "outlined",
              disabled: _ctx.isUploading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("global.prev")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.currentStep < 3)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.nextClick())),
              "show-loading": _ctx.isUploading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("global.next")), 1)
              ]),
              _: 1
            }, 8, ["show-loading"]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === 3)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit())),
              "show-loading": _ctx.isUploading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("global.submit")), 1)
              ]),
              _: 1
            }, 8, ["show-loading"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}